export const getCookieDomain = () => {
    const config = useRuntimeConfig();
    const siteUrl = config.public.siteUrl;

    if (!siteUrl) return undefined;

    try {
        const url = new URL(siteUrl);
        const hostname = url.hostname;

        // Si on est en local avec ddev
        if (hostname.endsWith('.ddev.site')) {
            return '.ddev.site';
        }

        // Pour la production, on pourrait vouloir extraire le domaine principal
        // mais pour l'instant on reste sur une approche simple adaptée au besoin exprimé.
        return hostname;
    } catch (e) {
        return undefined;
    }
};
